"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCancelByDate = exports.mapConfirmationDataRoomContent = exports.mapRoomsDataRoomContent = exports.mapRoomsDataOfferContent = exports.mapOfferContent = exports.priceLabelAveragePerNight = exports.priceLabelAllInPricingFeesIncluded = exports.priceLabelAllInPricing = exports.ContentError = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const _1 = require(".");
class ContentError extends Error {
    constructor(message) {
        super(message);
        Object.setPrototypeOf(this, ContentError.prototype);
    }
}
exports.ContentError = ContentError;
const priceLabelAveragePerNight = 'Avg. price per night';
exports.priceLabelAveragePerNight = priceLabelAveragePerNight;
const priceLabelAllInPricing = 'All-in per night';
exports.priceLabelAllInPricing = priceLabelAllInPricing;
const priceLabelAllInPricingFeesIncluded = 'All-in per night (fees included)';
exports.priceLabelAllInPricingFeesIncluded = priceLabelAllInPricingFeesIncluded;
const mapOfferContent = (offer, property, price, resortFees, ppOffer, priceLabel, allInPricing) => {
    var _a;
    const mappedOffer = {
        owsCode: offer.owsCode || '',
        orsCode: offer.orsCode || '',
        ppCode: offer.ppCode || '',
        title: offer.title || '',
        shortDescription: _1.formatBeverlyWilshire(offer.shortDescription),
        longDescription: _1.formatBeverlyWilshire(offer.longDescription),
        whatsIncludedTitleDictKey: offer.inclusionsArray.length
            ? _1.setDictionaryKey("What's Included")
            : _1.setDictionaryKey('View more details'),
        price,
        priceLabel,
        feesDisclaimer: getFeesDisclaimer(property, resortFees, allInPricing),
        inclusionsTitle: offer.inclusions.length ? _1.setDictionaryKey('Included') : undefined,
        inclusions: offer.inclusions.map(inclusion => {
            return {
                title: inclusion.title,
                items: inclusion.items.map(item => _1.formatBeverlyWilshire(item)),
            };
        }),
        extraInclusions: [],
        conditionsTitle: offer.conditions.length ? _1.setDictionaryKey('Conditions') : undefined,
        conditions: offer.conditions.map(condition => {
            return {
                title: condition.title,
                items: condition.items.map(item => _1.formatBeverlyWilshire(item)),
            };
        }),
        disclaimer: _1.formatBeverlyWilshire(property.propertyDisclaimer),
        ppOffer,
    };
    if (offer.image) {
        mappedOffer.image = {
            path: offer.image,
        };
    }
    if (property.reservationPhone || property.propertyPhone) {
        mappedOffer.bookDirectPhone = {
            number: property.reservationPhone || property.propertyPhone || '',
        };
    }
    if (ppOffer) {
        mappedOffer.title = `Preferred Partner - ${offer.title}`;
        if ((_a = offer.ppAmenities) === null || _a === void 0 ? void 0 : _a.length) {
            mappedOffer.extraInclusions.push({
                title: 'Exclusive Preferred Partner Benefits',
                items: offer.ppAmenities,
            });
        }
    }
    return mappedOffer;
};
exports.mapOfferContent = mapOfferContent;
const mapRoomsDataOfferContent = (offer, property, price, resortFees, ppOffer, allInPricing) => {
    return Object.assign(Object.assign({}, mapOfferContent(offer, property, price, resortFees, ppOffer, offer.priceLabel, allInPricing)), { priceId: offer.priceId, resultId: offer.resultId });
};
exports.mapRoomsDataOfferContent = mapRoomsDataOfferContent;
const mapRoomContent = (room) => {
    const mappedRoom = {
        name: room.title || '',
        description: _1.formatBeverlyWilshire(room.unitLongDescription),
        view: room.view,
        size: room.size,
        floorPlanImage: room.floorPlanImagePath ? { path: room.floorPlanImagePath } : undefined,
        occupancy: room.occupancyString,
        extraBed: room.extraBed,
        location: room.location,
        bathroom: room.bathroomDescription,
        servicesAndAmenityGroups: [],
        accessibleFeaturesList: room.accessibleFeaturesList && room.accessibleFeaturesList.length > 0
            ? room.accessibleFeaturesList.map(feature => _1.formatBeverlyWilshire(feature))
            : undefined,
    };
    if (room.servicesAndAmenities.amenityGroups.length) {
        const size = Math.ceil(room.servicesAndAmenities.amenityGroups.length / 2);
        const amenityGroups = [
            room.servicesAndAmenities.amenityGroups.slice(0, size),
            room.servicesAndAmenities.amenityGroups.slice(size, room.servicesAndAmenities.amenityGroups.length),
        ];
        amenityGroups.forEach(amenityGroup => {
            const servicesAndAmenities = amenityGroup.reduce((amenities, amenity) => {
                amenities.push({
                    title: amenity.title || '',
                    amenities: amenity.amenityItems,
                });
                return amenities;
            }, []);
            mappedRoom.servicesAndAmenityGroups.push({
                servicesAndAmenities,
            });
        });
    }
    return mappedRoom;
};
const mapRoomsDataRoomContent = (room, property, bedOptions, bedTypes, lowestRate, resortFees, priceLabel, allInPricing) => {
    const mappedRoom = Object.assign(Object.assign({}, mapRoomContent(room)), { images: [], lowestRate, feesDisclaimer: getFeesDisclaimer(property, resortFees, allInPricing), priceLabel, bedOptions: bedOptions.join(' / '), bookableOnline: !!room.owsCode, bedTypes });
    room.images.forEach(image => {
        mappedRoom.images.push({
            path: image,
        });
    });
    if (!room.owsCode) {
        mappedRoom.bookDirectData = {
            titleDictKey: _1.setDictionaryKey('To Book this Room<br/>Please Call', [], true),
            telephones: [],
        };
        if (room.bookDirectTelephone && room.bookDirectTitle && !property.propertyPhone) {
            mappedRoom.bookDirectData.hotelReservations = _1.setDictionaryKey(room.bookDirectTitle);
        }
        const bookDirectPhone = room.bookDirectTelephone || property.propertyPhone;
        if (bookDirectPhone) {
            bookDirectPhone.split(';').forEach(phone => {
                var _a;
                if (phone.trim()) {
                    (_a = mappedRoom.bookDirectData) === null || _a === void 0 ? void 0 : _a.telephones.push({
                        number: phone.trim(),
                    });
                }
            });
        }
    }
    return mappedRoom;
};
exports.mapRoomsDataRoomContent = mapRoomsDataRoomContent;
const mapConfirmationDataRoomContent = (room) => {
    return Object.assign(Object.assign({}, mapRoomContent(room)), { bedType: room.bedTypeDescription || '' });
};
exports.mapConfirmationDataRoomContent = mapConfirmationDataRoomContent;
const getCancelByDate = (terms, propertyTimezone) => {
    if (terms.find(term => !term.cancellationBy)) {
        return undefined;
    }
    const timezone = propertyTimezone || moment_timezone_1.default.tz.guess();
    const cancelBy = terms.reduce((cancelDate, term) => {
        if (term.cancellationBy) {
            if (cancelDate) {
                const thisTermCancel = moment_timezone_1.default(term.cancellationBy).tz(timezone);
                if (thisTermCancel.isBefore(cancelDate)) {
                    return thisTermCancel;
                }
            }
            else {
                return moment_timezone_1.default(term.cancellationBy).tz(timezone);
            }
        }
        return cancelDate;
    }, undefined);
    return cancelBy
        ? new Date(moment_timezone_1.default(cancelBy.format('YYYY-MM-DDTHH:mm:ss')).valueOf())
        : cancelBy;
};
exports.getCancelByDate = getCancelByDate;
const getFeesDisclaimer = (property, resortFees, allInPricing) => {
    if (allInPricing) {
        return undefined;
    }
    const defaultResortFeesIncludedDisclaimerPreCheckout = 'Includes {0} Resort Fee (taxes calculated at checkout)';
    let { feesDisclaimerText } = property;
    const feesDisclaimerParams = [];
    if (resortFees) {
        feesDisclaimerText =
            property.disclaimerTextResortFeesIncludedPreCheckout ||
                defaultResortFeesIncludedDisclaimerPreCheckout;
        feesDisclaimerParams.push(`${resortFees.currency} ${resortFees.amount.withDecimal}`.trim());
    }
    if (feesDisclaimerText) {
        return _1.setDictionaryKey(feesDisclaimerText, feesDisclaimerParams);
    }
    return undefined;
};
